import React from "react"
import SelectDropdown from "../SelectDropdown"
import FormSection from "../FormSection"
import TextAreaInput from "../TextAreaInput"
import Checkbox from "../multi-select/Checkbox"

export default function BuildingProject() {
  const property = [
    { value: "", label: "Please Select" },
    { value: "investment", label: "Investment" },
    { value: "owner-occupied", label: "Owner Occupied" }
  ]

  const finance = [
    { value: "", label: "Please Select" },
    { value: "lender", label: "Finance application lodged with a lender" },
    { value: "approved", label: "Finance approved" },
    { value: "broker-needed", label: "Need a mortgage broker" }
  ]

  const priceGuide = [
    { value: "", label: "Please Select" },
    { value: "0-50k", label: "$0 to $50,000" },
    { value: "50k-100k", label: "$50,000 to $100,000" },
    { value: "100k-200k", label: "$100,000 to $200,000" },
    { value: "200k-350k", label: "$200,000 to $350,000" },
    { value: "350k-500k", label: "$350,000 to $500,000" },
    { value: "500k-1m", label: "$500,000 to $1 million" },
    { value: "1m-2m", label: "$1 million to $2 million" },
    { value: "2m-5m", label: "$2 million to $5 million" },
    { value: "5m-10m", label: "$5 million to $10 million" },
    { value: "10m+", label: "$10 million +" }
  ]

  const timeFrame = [
    { value: "", label: "Please Select" },
    { value: "ready-to-go", label: "Ready to go" },
    { value: "0-3months", label: "0 to 3 months" },
    { value: "3-6months", label: "3 to 6 months" },
    { value: "6-9months", label: "6 to 9 months" },
    { value: "9-12months", label: "9 to 12 months" },
    { value: "12+months", label: "More than 12 months" }
  ]

  const projectQualities = [
    { value: "Outdoor Projects eg. Alfresco/Pools" },
    { value: "New Home Builders (Custom)" },
    { value: "Renovations/Alterations" },
    { value: "Luxury" },
    { value: "Second Storey Additions" },
    { value: "Duplex" },
    { value: "Town Houses/Villas" },
    { value: "Boutique Apartments" },
    { value: "Multi-Unit/Large Apartments" },
    { value: "Commercial" },
    { value: "Industrial" },
    { value: "Heritage/Restoration" },
    { value: "Remedial" },
    { value: "Knockdown Rebuild" },
    { value: "Narrow Block" },
    { value: "Sloping Block" },
    { value: "Granny Flat" },
    { value: "Demolition Service" },
    { value: "Excavation Service" }
  ]

  const externalFeatures = [
    { value: "Termite Treated Timber" },
    { value: "Steel Frame" },
    { value: "Sarking" },
    { value: "Tile Roof" },
    { value: "Colorbond Roof" },
    { value: "Landscaping" },
    { value: "Fencing" },
    { value: "Driveway" },
    { value: "Clothesline" },
    { value: "TV Antenna" },
    { value: "Letterbox" },
    { value: "Flyscreens" },
    { value: "Tiling To Alfresco" },
    { value: "Rainwater Tank" },
    { value: "Service Connections" },
    { value: "Security Screens" },
    { value: "Pools" },
    { value: "Balcony" },
    { value: "Alfresco" },
  ]

  const internalFeatures = [
    { value: "Flooring" },
    { value: "Blinds/Curtains" },
    { value: "Raised Ceiling" },
    { value: "Feature Walls" },
    { value: "Niches/Alcoves" },
    { value: "Walk In Linen" },
    { value: "Walk In Robe" },
    { value: "Home Theatre" },
    { value: "Study/Home Office" },
    { value: "Rumpus" },
    { value: "Separate Living/Dining" },
    { value: "Rear Master Bedroom" },
    { value: "Powder Room" },
    { value: "Laundry Chute" },
    { value: "Mud Room" },
  ]

  const kitchen = [
    { value: "Oven" },
    { value: "Cooktop" },
    { value: "Rangehood" },
    { value: "Dishwasher" },
    { value: "Microwave" },
    { value: "Stone Benchtop" },
    { value: "Walk In Pantry" },
    { value: "Butler's Pantry" },
  ]

  const bathroomEnsuite = [
    { value: "Floor To Ceiling Tiles" },
    { value: "Frameless Showerscreen" },
    { value: "Soft Close Toilet Seat" },
    { value: "Bathroom Door Locks" },
    { value: "Ensuite Door" },
    { value: "Separate Toilet" },
    { value: "Vanity with single basin" },
    { value: "Vanity with double basins" },
  ]

  const electricalGas = [
    { value: "Ducted Air Conditioning" },
    { value: "Split System Air Conditioning" },
    { value: "Ceiling Fans" },
    { value: "Alarm" },
    { value: "Smoke Detectors" },
    { value: "Gas Point" },
    { value: "TV Points" },
    { value: "Data Points" },
    { value: "Telephone Points" },
    { value: "Lights" },
    { value: "Down Lights" },
    { value: "Outdoor Up/Down Lights" },
]

  return (
    <FormSection title="Your Building Project">
      <div className="grid grid-cols-2 gap-y-6">
        <SelectDropdown
          label="Property"
          name="property"
          as="select"
          options={property}
          className="flex flex-col mr-32"
        />
        <SelectDropdown
          label="Finance"
          name="finance"
          as="select"
          options={finance}
          className="flex flex-col mr-32"
        />
        <SelectDropdown
          label="Price Guide"
          name="price_guide"
          as="select"
          options={priceGuide}
          className="flex flex-col mr-32"
        />
        <SelectDropdown
          label="Time Frame"
          name="time_frame"
          as="select"
          options={timeFrame}
          className="flex flex-col mr-32"
        />
        <TextAreaInput
          label={
            <>
              <p>Please describe your building project. Please include:</p>
              <p>
                How many storeys, bedrooms, bathrooms and garages, Block width
                (m), block length (m) and house size (m²)
              </p>
              <p className="text-red-500">
                (Round up to the nearest whole number)
              </p>
            </>
          }
          name="project_description"
          className="flex flex-col col-span-2"
        />
      </div>
      <div className="space-y-6 mt-6">
        <Checkbox
          label="please select build categories that most reflect your requirements"
          name="project_qualities"
          options={projectQualities}
        />
        <Checkbox
          label="external features (optional)"
          name="external_features"
          options={externalFeatures}
        />
        <Checkbox
          label="internal features (optional)"
          name="internal_features"
          options={internalFeatures}
        />
        <Checkbox
          label="kitchen (optional)"
          name="kitchen"
          options={kitchen}
        />
        <Checkbox
          label="bathroom/ensuite features (optional)"
          name="bathroom_ensuite_features"
          options={bathroomEnsuite}
        />
        <Checkbox
          label="electrical/gas features (optional)"
          name="electrical_gas_features"
          options={electricalGas}
        />
      </div>
    </FormSection>
  )
}
